import { Util } from "./util.js";
import { WishlistHeartV1 } from "./wishlistheart_v1.js";

const util = new Util();
const DEFAULT_COMBO_INFO_FOR_ARTICLE = Object.freeze({ comboType: "UNKNOWN" });

export class Article {
	constructor(dom, wishlist, comboInfoForArticle = DEFAULT_COMBO_INFO_FOR_ARTICLE, isArticleInTopicPage = false) {
		this.dom = dom;
		this.id = util.readFromDataAttribute(dom, "article_id");
		this.variationId = util.readFromDataAttribute(dom, "variation_id");
		this.position = Number.parseInt(util.readFromDataAttribute(dom, "article_position"));
		this.wishlistHeartV1 = new WishlistHeartV1(
			dom,
			"combo_article--wishlistheart",
			wishlist,
			this.variationId,
			comboInfoForArticle,
			isArticleInTopicPage
		);
	}

	addClickHandlerForWishlistBtn() {
		this.wishlistHeartV1.addClickHandlerForWishlistBtn();
	}

	getDom() {
		return this.dom;
	}

	getId() {
		return this.id;
	}

	getVariationId() {
		return this.variationId;
	}

	getPosition() {
		return this.position;
	}

	get onWishlist() {
		return this.wishlistHeartV1.onWishlist;
	}

	set onWishlist(value) {
		this.wishlistHeartV1.onWishlist = value;
	}

	get wishlistHeartDom() {
		return this.wishlistHeartV1.wishlistHeartDom;
	}
}
